export default __webpack_public_path__ + "static/media/Key_fill.27d279f9.svg";